const _excluded = ["zoom", "toolbar", "render", "controller"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { useLightboxProps, useMotionPreference, useEventCallback, useLayoutEffect, useLightboxState, isImageSlide, isImageFitCover, round, useDocumentContext, useController, usePointerEvents, cleanup, makeUseContext, createIcon, IconButton, devicePixelRatio, ImageSlide, clsx, cssClass, addToolbarButton, createModule } from '../../index.js';
import { EVENT_ON_KEY_DOWN, EVENT_ON_WHEEL, UNKNOWN_ACTION_TYPE, CLASS_FULLSIZE, CLASS_FLEX_CENTER, CLASS_SLIDE_WRAPPER, CLASS_SLIDE_WRAPPER_INTERACTIVE, PLUGIN_ZOOM } from '../../types.js';
const defaultZoomProps = {
  maxZoomPixelRatio: 1,
  zoomInMultiplier: 2,
  doubleTapDelay: 300,
  doubleClickDelay: 500,
  doubleClickMaxStops: 2,
  keyboardMoveDistance: 50,
  wheelZoomDistanceFactor: 100,
  pinchZoomDistanceFactor: 100,
  scrollToZoom: false
};
const resolveZoomProps = zoom => _objectSpread(_objectSpread({}, defaultZoomProps), zoom);
function useZoomAnimation(zoom, offsetX, offsetY, zoomWrapperRef) {
  const zoomAnimation = React.useRef(undefined);
  const zoomAnimationStart = React.useRef(undefined);
  const zoomAnimationDuration = useLightboxProps().animation.zoom;
  const reduceMotion = useMotionPreference();
  const playZoomAnimation = useEventCallback(() => {
    var _a, _b, _c;
    (_a = zoomAnimation.current) === null || _a === void 0 ? void 0 : _a.cancel();
    zoomAnimation.current = undefined;
    if (zoomAnimationStart.current && (zoomWrapperRef === null || zoomWrapperRef === void 0 ? void 0 : zoomWrapperRef.current)) {
      try {
        zoomAnimation.current = (_c = (_b = zoomWrapperRef.current).animate) === null || _c === void 0 ? void 0 : _c.call(_b, [{
          transform: zoomAnimationStart.current
        }, {
          transform: `scale(${zoom}) translateX(${offsetX}px) translateY(${offsetY}px)`
        }], {
          duration: !reduceMotion ? zoomAnimationDuration !== null && zoomAnimationDuration !== void 0 ? zoomAnimationDuration : 500 : 0,
          easing: zoomAnimation.current ? "ease-out" : "ease-in-out"
        });
      } catch (err) {
        console.error(err);
      }
      zoomAnimationStart.current = undefined;
      if (zoomAnimation.current) {
        zoomAnimation.current.onfinish = () => {
          zoomAnimation.current = undefined;
        };
      }
    }
  });
  useLayoutEffect(playZoomAnimation, [zoom, offsetX, offsetY, playZoomAnimation]);
  return React.useCallback(() => {
    zoomAnimationStart.current = (zoomWrapperRef === null || zoomWrapperRef === void 0 ? void 0 : zoomWrapperRef.current) ? window.getComputedStyle(zoomWrapperRef.current).transform : undefined;
  }, [zoomWrapperRef]);
}
function useZoomCallback(zoom, disabled) {
  const _useLightboxProps = useLightboxProps(),
    on = _useLightboxProps.on;
  const onZoomCallback = useEventCallback(() => {
    var _a;
    if (!disabled) {
      (_a = on.zoom) === null || _a === void 0 ? void 0 : _a.call(on, {
        zoom
      });
    }
  });
  React.useEffect(onZoomCallback, [zoom, onZoomCallback]);
}
function useZoomProps() {
  const _useLightboxProps2 = useLightboxProps(),
    zoom = _useLightboxProps2.zoom;
  return resolveZoomProps(zoom);
}
function useZoomImageRect(slideRect, imageDimensions) {
  var _a, _b;
  let imageRect = {
    width: 0,
    height: 0
  };
  let maxImageRect = {
    width: 0,
    height: 0
  };
  const _useLightboxState = useLightboxState(),
    currentSlide = _useLightboxState.currentSlide;
  const imageFit = useLightboxProps().carousel.imageFit;
  const _useZoomProps = useZoomProps(),
    maxZoomPixelRatio = _useZoomProps.maxZoomPixelRatio;
  if (slideRect && currentSlide) {
    const slide = _objectSpread(_objectSpread({}, currentSlide), imageDimensions);
    if (isImageSlide(slide)) {
      const cover = isImageFitCover(slide, imageFit);
      const width = Math.max(...(((_a = slide.srcSet) === null || _a === void 0 ? void 0 : _a.map(x => x.width)) || []).concat(slide.width ? [slide.width] : []));
      const height = Math.max(...(((_b = slide.srcSet) === null || _b === void 0 ? void 0 : _b.map(x => x.height)) || []).concat(slide.height ? [slide.height] : []));
      if (width > 0 && height > 0 && slideRect.width > 0 && slideRect.height > 0) {
        maxImageRect = cover ? {
          width: Math.round(Math.min(width, slideRect.width / slideRect.height * height)),
          height: Math.round(Math.min(height, slideRect.height / slideRect.width * width))
        } : {
          width,
          height
        };
        maxImageRect = {
          width: maxImageRect.width * maxZoomPixelRatio,
          height: maxImageRect.height * maxZoomPixelRatio
        };
        imageRect = cover ? {
          width: Math.min(slideRect.width, maxImageRect.width, width),
          height: Math.min(slideRect.height, maxImageRect.height, height)
        } : {
          width: Math.round(Math.min(slideRect.width, slideRect.height / height * width, width)),
          height: Math.round(Math.min(slideRect.height, slideRect.width / width * height, height))
        };
      }
    }
  }
  const maxZoom = imageRect.width ? Math.max(round(maxImageRect.width / imageRect.width, 5), 1) : 1;
  return {
    imageRect,
    maxZoom
  };
}
function distance(pointerA, pointerB) {
  return ((pointerA.clientX - pointerB.clientX) ** 2 + (pointerA.clientY - pointerB.clientY) ** 2) ** 0.5;
}
function scaleZoom(value, delta) {
  let factor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  let clamp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  return value * Math.min(1 + Math.abs(delta / factor), clamp) ** Math.sign(delta);
}
function useZoomSensors(zoom, maxZoom, disabled, changeZoom, changeOffsets, zoomWrapperRef) {
  const activePointers = React.useRef([]);
  const lastPointerDown = React.useRef(0);
  const pinchZoomDistance = React.useRef(undefined);
  const _useLightboxState2 = useLightboxState(),
    globalIndex = _useLightboxState2.globalIndex;
  const _useDocumentContext = useDocumentContext(),
    getOwnerWindow = _useDocumentContext.getOwnerWindow;
  const _useController = useController(),
    containerRef = _useController.containerRef,
    subscribeSensors = _useController.subscribeSensors;
  const _useZoomProps2 = useZoomProps(),
    keyboardMoveDistance = _useZoomProps2.keyboardMoveDistance,
    zoomInMultiplier = _useZoomProps2.zoomInMultiplier,
    wheelZoomDistanceFactor = _useZoomProps2.wheelZoomDistanceFactor,
    scrollToZoom = _useZoomProps2.scrollToZoom,
    doubleTapDelay = _useZoomProps2.doubleTapDelay,
    doubleClickDelay = _useZoomProps2.doubleClickDelay,
    doubleClickMaxStops = _useZoomProps2.doubleClickMaxStops,
    pinchZoomDistanceFactor = _useZoomProps2.pinchZoomDistanceFactor;
  const translateCoordinates = React.useCallback(event => {
    if (containerRef.current) {
      const pageX = event.pageX,
        pageY = event.pageY;
      const _getOwnerWindow = getOwnerWindow(),
        scrollX = _getOwnerWindow.scrollX,
        scrollY = _getOwnerWindow.scrollY;
      const _containerRef$current = containerRef.current.getBoundingClientRect(),
        left = _containerRef$current.left,
        top = _containerRef$current.top,
        width = _containerRef$current.width,
        height = _containerRef$current.height;
      return [pageX - left - scrollX - width / 2, pageY - top - scrollY - height / 2];
    }
    return [];
  }, [containerRef, getOwnerWindow]);
  const onKeyDown = useEventCallback(event => {
    const key = event.key,
      metaKey = event.metaKey,
      ctrlKey = event.ctrlKey;
    const meta = metaKey || ctrlKey;
    const preventDefault = () => {
      event.preventDefault();
      event.stopPropagation();
    };
    if (zoom > 1) {
      const move = (deltaX, deltaY) => {
        preventDefault();
        changeOffsets(deltaX, deltaY);
      };
      if (key === "ArrowDown") {
        move(0, keyboardMoveDistance);
      } else if (key === "ArrowUp") {
        move(0, -keyboardMoveDistance);
      } else if (key === "ArrowLeft") {
        move(-keyboardMoveDistance, 0);
      } else if (key === "ArrowRight") {
        move(keyboardMoveDistance, 0);
      }
    }
    const handleChangeZoom = zoomValue => {
      preventDefault();
      changeZoom(zoomValue);
    };
    if (key === "+" || meta && key === "=") {
      handleChangeZoom(zoom * zoomInMultiplier);
    } else if (key === "-" || meta && key === "_") {
      handleChangeZoom(zoom / zoomInMultiplier);
    } else if (meta && key === "0") {
      handleChangeZoom(1);
    }
  });
  const onWheel = useEventCallback(event => {
    if (event.ctrlKey || scrollToZoom) {
      if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
        event.stopPropagation();
        changeZoom(scaleZoom(zoom, -event.deltaY, wheelZoomDistanceFactor), true, ...translateCoordinates(event));
        return;
      }
    }
    if (zoom > 1) {
      event.stopPropagation();
      if (!scrollToZoom) {
        changeOffsets(event.deltaX, event.deltaY);
      }
    }
  });
  const clearPointer = React.useCallback(event => {
    const pointers = activePointers.current;
    pointers.splice(0, pointers.length, ...pointers.filter(p => p.pointerId !== event.pointerId));
  }, []);
  const replacePointer = React.useCallback(event => {
    clearPointer(event);
    event.persist();
    activePointers.current.push(event);
  }, [clearPointer]);
  const onPointerDown = useEventCallback(event => {
    var _a;
    const pointers = activePointers.current;
    if (event.pointerType === "mouse" && event.buttons > 1 || !((_a = zoomWrapperRef === null || zoomWrapperRef === void 0 ? void 0 : zoomWrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
      return;
    }
    if (zoom > 1) {
      event.stopPropagation();
    }
    const timeStamp = event.timeStamp;
    if (pointers.length === 0 && timeStamp - lastPointerDown.current < (event.pointerType === "touch" ? doubleTapDelay : doubleClickDelay)) {
      lastPointerDown.current = 0;
      changeZoom(zoom !== maxZoom ? zoom * Math.max(maxZoom ** (1 / doubleClickMaxStops), zoomInMultiplier) : 1, false, ...translateCoordinates(event));
    } else {
      lastPointerDown.current = timeStamp;
    }
    replacePointer(event);
    if (pointers.length === 2) {
      pinchZoomDistance.current = distance(pointers[0], pointers[1]);
    }
  });
  const onPointerMove = useEventCallback(event => {
    const pointers = activePointers.current;
    const activePointer = pointers.find(p => p.pointerId === event.pointerId);
    if (pointers.length === 2 && pinchZoomDistance.current) {
      event.stopPropagation();
      replacePointer(event);
      const currentDistance = distance(pointers[0], pointers[1]);
      const delta = currentDistance - pinchZoomDistance.current;
      if (Math.abs(delta) > 0) {
        changeZoom(scaleZoom(zoom, delta, pinchZoomDistanceFactor), true, ...pointers.map(x => translateCoordinates(x)).reduce((acc, coordinate) => coordinate.map((x, i) => acc[i] + x / 2)));
        pinchZoomDistance.current = currentDistance;
      }
      return;
    }
    if (zoom > 1) {
      event.stopPropagation();
      if (activePointer) {
        if (pointers.length === 1) {
          changeOffsets((activePointer.clientX - event.clientX) / zoom, (activePointer.clientY - event.clientY) / zoom);
        }
        replacePointer(event);
      }
    }
  });
  const onPointerUp = React.useCallback(event => {
    const pointers = activePointers.current;
    if (pointers.length === 2 && pointers.find(p => p.pointerId === event.pointerId)) {
      pinchZoomDistance.current = undefined;
    }
    clearPointer(event);
  }, [clearPointer]);
  const cleanupSensors = React.useCallback(() => {
    const pointers = activePointers.current;
    pointers.splice(0, pointers.length);
    lastPointerDown.current = 0;
    pinchZoomDistance.current = undefined;
  }, []);
  usePointerEvents(subscribeSensors, onPointerDown, onPointerMove, onPointerUp, disabled);
  React.useEffect(cleanupSensors, [globalIndex, cleanupSensors]);
  React.useEffect(() => {
    if (!disabled) {
      return cleanup(cleanupSensors, subscribeSensors(EVENT_ON_KEY_DOWN, onKeyDown), subscribeSensors(EVENT_ON_WHEEL, onWheel));
    }
    return () => {};
  }, [disabled, subscribeSensors, cleanupSensors, onKeyDown, onWheel]);
}
function useZoomState(imageRect, maxZoom, zoomWrapperRef) {
  const _React$useState = React.useState(1),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    zoom = _React$useState2[0],
    setZoom = _React$useState2[1];
  const _React$useState3 = React.useState(0),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    offsetX = _React$useState4[0],
    setOffsetX = _React$useState4[1];
  const _React$useState5 = React.useState(0),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    offsetY = _React$useState6[0],
    setOffsetY = _React$useState6[1];
  const animate = useZoomAnimation(zoom, offsetX, offsetY, zoomWrapperRef);
  const _useLightboxState3 = useLightboxState(),
    currentSlide = _useLightboxState3.currentSlide,
    globalIndex = _useLightboxState3.globalIndex;
  const _useController2 = useController(),
    containerRect = _useController2.containerRect,
    slideRect = _useController2.slideRect;
  const _useZoomProps3 = useZoomProps(),
    zoomInMultiplier = _useZoomProps3.zoomInMultiplier;
  const currentSource = currentSlide && isImageSlide(currentSlide) ? currentSlide.src : undefined;
  const disabled = !currentSource || !(zoomWrapperRef === null || zoomWrapperRef === void 0 ? void 0 : zoomWrapperRef.current);
  useLayoutEffect(() => {
    setZoom(1);
    setOffsetX(0);
    setOffsetY(0);
  }, [globalIndex, currentSource]);
  const changeOffsets = React.useCallback((dx, dy, targetZoom) => {
    const newZoom = targetZoom || zoom;
    const newOffsetX = offsetX - (dx || 0);
    const newOffsetY = offsetY - (dy || 0);
    const maxOffsetX = (imageRect.width * newZoom - slideRect.width) / 2 / newZoom;
    const maxOffsetY = (imageRect.height * newZoom - slideRect.height) / 2 / newZoom;
    setOffsetX(Math.min(Math.abs(newOffsetX), Math.max(maxOffsetX, 0)) * Math.sign(newOffsetX));
    setOffsetY(Math.min(Math.abs(newOffsetY), Math.max(maxOffsetY, 0)) * Math.sign(newOffsetY));
  }, [zoom, offsetX, offsetY, slideRect, imageRect.width, imageRect.height]);
  const changeZoom = React.useCallback((targetZoom, rapid, dx, dy) => {
    const newZoom = round(Math.min(Math.max(targetZoom + 0.001 < maxZoom ? targetZoom : maxZoom, 1), maxZoom), 5);
    if (newZoom === zoom) return;
    if (!rapid) {
      animate();
    }
    changeOffsets(dx ? dx * (1 / zoom - 1 / newZoom) : 0, dy ? dy * (1 / zoom - 1 / newZoom) : 0, newZoom);
    setZoom(newZoom);
  }, [zoom, maxZoom, changeOffsets, animate]);
  const handleControllerRectChange = useEventCallback(() => {
    if (zoom > 1) {
      if (zoom > maxZoom) {
        changeZoom(maxZoom, true);
      }
      changeOffsets();
    }
  });
  useLayoutEffect(handleControllerRectChange, [containerRect.width, containerRect.height, handleControllerRectChange]);
  const zoomIn = React.useCallback(() => changeZoom(zoom * zoomInMultiplier), [zoom, zoomInMultiplier, changeZoom]);
  const zoomOut = React.useCallback(() => changeZoom(zoom / zoomInMultiplier), [zoom, zoomInMultiplier, changeZoom]);
  return {
    zoom,
    offsetX,
    offsetY,
    disabled,
    changeOffsets,
    changeZoom,
    zoomIn,
    zoomOut
  };
}
const ZoomControllerContext = /*#__PURE__*/React.createContext(null);
const useZoom = makeUseContext("useZoom", "ZoomControllerContext", ZoomControllerContext);
function ZoomContextProvider(_ref) {
  let children = _ref.children;
  const _React$useState7 = React.useState(),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    zoomWrapper = _React$useState8[0],
    setZoomWrapper = _React$useState8[1];
  const _useController3 = useController(),
    slideRect = _useController3.slideRect;
  const _useZoomImageRect = useZoomImageRect(slideRect, zoomWrapper === null || zoomWrapper === void 0 ? void 0 : zoomWrapper.imageDimensions),
    imageRect = _useZoomImageRect.imageRect,
    maxZoom = _useZoomImageRect.maxZoom;
  const _useZoomState = useZoomState(imageRect, maxZoom, zoomWrapper === null || zoomWrapper === void 0 ? void 0 : zoomWrapper.zoomWrapperRef),
    zoom = _useZoomState.zoom,
    offsetX = _useZoomState.offsetX,
    offsetY = _useZoomState.offsetY,
    disabled = _useZoomState.disabled,
    changeZoom = _useZoomState.changeZoom,
    changeOffsets = _useZoomState.changeOffsets,
    zoomIn = _useZoomState.zoomIn,
    zoomOut = _useZoomState.zoomOut;
  useZoomCallback(zoom, disabled);
  useZoomSensors(zoom, maxZoom, disabled, changeZoom, changeOffsets, zoomWrapper === null || zoomWrapper === void 0 ? void 0 : zoomWrapper.zoomWrapperRef);
  const zoomRef = React.useMemo(() => ({
    zoom,
    maxZoom,
    offsetX,
    offsetY,
    disabled,
    zoomIn,
    zoomOut,
    changeZoom
  }), [zoom, maxZoom, offsetX, offsetY, disabled, zoomIn, zoomOut, changeZoom]);
  React.useImperativeHandle(useZoomProps().ref, () => zoomRef, [zoomRef]);
  const context = React.useMemo(() => _objectSpread(_objectSpread({}, zoomRef), {}, {
    setZoomWrapper
  }), [zoomRef, setZoomWrapper]);
  return /*#__PURE__*/React.createElement(ZoomControllerContext.Provider, {
    value: context
  }, children);
}
const ZoomInIcon = createIcon("ZoomIn", /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
})));
const ZoomOutIcon = createIcon("ZoomOut", /*#__PURE__*/React.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
}));
const ZoomButton = /*#__PURE__*/React.forwardRef(function ZoomButton(_ref2, ref) {
  let zoomIn = _ref2.zoomIn,
    onLoseFocus = _ref2.onLoseFocus;
  const wasEnabled = React.useRef(false);
  const wasFocused = React.useRef(false);
  const _useZoom = useZoom(),
    zoom = _useZoom.zoom,
    maxZoom = _useZoom.maxZoom,
    zoomInCallback = _useZoom.zoomIn,
    zoomOutCallback = _useZoom.zoomOut,
    zoomDisabled = _useZoom.disabled;
  const _useLightboxProps3 = useLightboxProps(),
    render = _useLightboxProps3.render;
  const disabled = zoomDisabled || (zoomIn ? zoom >= maxZoom : zoom <= 1);
  React.useEffect(() => {
    if (disabled && wasEnabled.current && wasFocused.current) {
      onLoseFocus();
    }
    if (!disabled) {
      wasEnabled.current = true;
    }
  }, [disabled, onLoseFocus]);
  return /*#__PURE__*/React.createElement(IconButton, {
    ref: ref,
    disabled: disabled,
    label: zoomIn ? "Zoom in" : "Zoom out",
    icon: zoomIn ? ZoomInIcon : ZoomOutIcon,
    renderIcon: zoomIn ? render.iconZoomIn : render.iconZoomOut,
    onClick: zoomIn ? zoomInCallback : zoomOutCallback,
    onFocus: () => {
      wasFocused.current = true;
    },
    onBlur: () => {
      wasFocused.current = false;
    }
  });
});
function ZoomButtonsGroup() {
  const zoomInRef = React.useRef(null);
  const zoomOutRef = React.useRef(null);
  const _useController4 = useController(),
    focus = _useController4.focus;
  const focusSibling = React.useCallback(sibling => {
    var _a, _b;
    if (!((_a = sibling.current) === null || _a === void 0 ? void 0 : _a.disabled)) {
      (_b = sibling.current) === null || _b === void 0 ? void 0 : _b.focus();
    } else {
      focus();
    }
  }, [focus]);
  const focusZoomIn = React.useCallback(() => focusSibling(zoomInRef), [focusSibling]);
  const focusZoomOut = React.useCallback(() => focusSibling(zoomOutRef), [focusSibling]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ZoomButton, {
    zoomIn: true,
    ref: zoomInRef,
    onLoseFocus: focusZoomOut
  }), /*#__PURE__*/React.createElement(ZoomButton, {
    ref: zoomOutRef,
    onLoseFocus: focusZoomIn
  }));
}
function ZoomToolbarControl() {
  const _useLightboxProps4 = useLightboxProps(),
    render = _useLightboxProps4.render;
  const zoomRef = useZoom();
  if (render.buttonZoom) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, render.buttonZoom(zoomRef));
  }
  return /*#__PURE__*/React.createElement(ZoomButtonsGroup, null);
}
function isResponsiveImageSlide(slide) {
  var _a;
  return (((_a = slide.srcSet) === null || _a === void 0 ? void 0 : _a.length) || 0) > 0;
}
function reducer(_ref3, _ref4) {
  let current = _ref3.current,
    preload = _ref3.preload;
  let type = _ref4.type,
    source = _ref4.source;
  switch (type) {
    case "fetch":
      if (!current) {
        return {
          current: source
        };
      }
      return {
        current,
        preload: source
      };
    case "done":
      if (source === preload) {
        return {
          current: source
        };
      }
      return {
        current,
        preload
      };
    default:
      throw new Error(UNKNOWN_ACTION_TYPE);
  }
}
function ResponsiveImage(props) {
  var _a, _b;
  const _React$useReducer = React.useReducer(reducer, {}),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    _React$useReducer2$ = _React$useReducer2[0],
    current = _React$useReducer2$.current,
    preload = _React$useReducer2$.preload,
    dispatch = _React$useReducer2[1];
  const image = props.slide,
    rect = props.rect,
    imageFit = props.imageFit,
    render = props.render,
    interactive = props.interactive;
  const srcSet = image.srcSet.sort((a, b) => a.width - b.width);
  const width = (_a = image.width) !== null && _a !== void 0 ? _a : srcSet[srcSet.length - 1].width;
  const height = (_b = image.height) !== null && _b !== void 0 ? _b : srcSet[srcSet.length - 1].height;
  const cover = isImageFitCover(image, imageFit);
  const maxWidth = Math.max(...srcSet.map(x => x.width));
  const targetWidth = Math.min((cover ? Math.max : Math.min)(rect.width, width * (rect.height / height)), maxWidth);
  const pixelDensity = devicePixelRatio();
  const handleResize = useEventCallback(() => {
    var _a;
    const targetSource = (_a = srcSet.find(x => x.width >= targetWidth * pixelDensity)) !== null && _a !== void 0 ? _a : srcSet[srcSet.length - 1];
    if (!current || srcSet.findIndex(x => x.src === current) < srcSet.findIndex(x => x === targetSource)) {
      dispatch({
        type: "fetch",
        source: targetSource.src
      });
    }
  });
  useLayoutEffect(handleResize, [rect.width, rect.height, pixelDensity, handleResize]);
  const handlePreload = useEventCallback(currentPreload => dispatch({
    type: "done",
    source: currentPreload
  }));
  const style = {
    WebkitTransform: !interactive ? "translateZ(0)" : "initial"
  };
  if (!cover) {
    Object.assign(style, rect.width / rect.height < width / height ? {
      width: "100%",
      height: "auto"
    } : {
      width: "auto",
      height: "100%"
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, preload && preload !== current && (/*#__PURE__*/React.createElement(ImageSlide, _objectSpread(_objectSpread({
    key: "preload"
  }, props), {}, {
    offset: undefined,
    slide: _objectSpread(_objectSpread({}, image), {}, {
      src: preload,
      srcSet: undefined
    }),
    style: _objectSpread({
      position: "absolute",
      visibility: "hidden"
    }, style),
    onLoad: () => handlePreload(preload),
    render: _objectSpread(_objectSpread({}, render), {}, {
      iconLoading: () => null,
      iconError: () => null
    })
  }))), current && (/*#__PURE__*/React.createElement(ImageSlide, _objectSpread(_objectSpread({
    key: "current"
  }, props), {}, {
    slide: _objectSpread(_objectSpread({}, image), {}, {
      src: current,
      srcSet: undefined
    }),
    style: style
  }))));
}
function ZoomWrapper(_ref5) {
  let render = _ref5.render,
    slide = _ref5.slide,
    offset = _ref5.offset,
    rect = _ref5.rect;
  var _a;
  const _React$useState9 = React.useState(),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    imageDimensions = _React$useState10[0],
    setImageDimensions = _React$useState10[1];
  const zoomWrapperRef = React.useRef(null);
  const _useZoom2 = useZoom(),
    zoom = _useZoom2.zoom,
    maxZoom = _useZoom2.maxZoom,
    offsetX = _useZoom2.offsetX,
    offsetY = _useZoom2.offsetY,
    setZoomWrapper = _useZoom2.setZoomWrapper;
  const interactive = zoom > 1;
  const _useLightboxProps5 = useLightboxProps(),
    carousel = _useLightboxProps5.carousel,
    on = _useLightboxProps5.on;
  const _useLightboxState4 = useLightboxState(),
    currentIndex = _useLightboxState4.currentIndex;
  useLayoutEffect(() => {
    if (offset === 0) {
      setZoomWrapper({
        zoomWrapperRef,
        imageDimensions
      });
      return () => setZoomWrapper(undefined);
    }
    return () => {};
  }, [offset, imageDimensions, setZoomWrapper]);
  let rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, {
    slide,
    offset,
    rect,
    zoom,
    maxZoom
  });
  if (!rendered && isImageSlide(slide)) {
    const slideProps = {
      slide,
      offset,
      rect,
      render,
      imageFit: carousel.imageFit,
      imageProps: carousel.imageProps,
      onClick: offset === 0 ? () => {
        var _a;
        return (_a = on.click) === null || _a === void 0 ? void 0 : _a.call(on, {
          index: currentIndex
        });
      } : undefined
    };
    rendered = isResponsiveImageSlide(slide) ? (/*#__PURE__*/React.createElement(ResponsiveImage, _objectSpread(_objectSpread({}, slideProps), {}, {
      slide: slide,
      interactive: interactive,
      rect: offset === 0 ? {
        width: rect.width * zoom,
        height: rect.height * zoom
      } : rect
    }))) : (/*#__PURE__*/React.createElement(ImageSlide, _objectSpread({
      onLoad: img => setImageDimensions({
        width: img.naturalWidth,
        height: img.naturalHeight
      })
    }, slideProps)));
  }
  if (!rendered) return null;
  return /*#__PURE__*/React.createElement("div", {
    ref: zoomWrapperRef,
    className: clsx(cssClass(CLASS_FULLSIZE), cssClass(CLASS_FLEX_CENTER), cssClass(CLASS_SLIDE_WRAPPER), interactive && cssClass(CLASS_SLIDE_WRAPPER_INTERACTIVE)),
    style: offset === 0 ? {
      transform: `scale(${zoom}) translateX(${offsetX}px) translateY(${offsetY}px)`
    } : undefined
  }, rendered);
}
const Zoom = _ref6 => {
  let augment = _ref6.augment,
    addModule = _ref6.addModule;
  augment(_ref7 => {
    let zoomProps = _ref7.zoom,
      toolbar = _ref7.toolbar,
      render = _ref7.render,
      controller = _ref7.controller,
      restProps = _objectWithoutProperties(_ref7, _excluded);
    const zoom = resolveZoomProps(zoomProps);
    return _objectSpread({
      zoom,
      toolbar: addToolbarButton(toolbar, PLUGIN_ZOOM, /*#__PURE__*/React.createElement(ZoomToolbarControl, null)),
      render: _objectSpread(_objectSpread({}, render), {}, {
        slide: props => {
          var _a;
          return isImageSlide(props.slide) ? /*#__PURE__*/React.createElement(ZoomWrapper, _objectSpread({
            render: render
          }, props)) : (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, props);
        }
      }),
      controller: _objectSpread(_objectSpread({}, controller), {}, {
        preventDefaultWheelY: zoom.scrollToZoom
      })
    }, restProps);
  });
  addModule(createModule(PLUGIN_ZOOM, ZoomContextProvider));
};
export { Zoom as default };